module.exports = __webpack_public_path__ + "static/law of civil wrongs-1837876496c40c2923c0f5107573f9a0.jpg";